import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import {Box, Button, Dialog, DialogContent, DialogTitle, Link, Stack} from '@mui/material';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import * as React from 'react';
import {useState} from 'react';
import {type DigitalCode} from '@/types/DigitalCode';
import Markdown from 'react-markdown';

type Props = {
    digitalCode: DigitalCode;
};

const DialogGetDigitalCode = ({digitalCode} : Props) : React.ReactElement => {
    const [modalOpen, setModalOpen] = useState(false);
    const dateAvailableAfterToday = new Date(digitalCode.releaseDate).getTime() > new Date().getTime();

    const handleOpen = () => {
        setModalOpen(true);
    };

    const handleClose = () => {
        setModalOpen(false);
    };

    const handleCopy = async () => {
        await navigator.clipboard.writeText(digitalCode.code);
    };

    return <>
        {dateAvailableAfterToday && <Box>Available {digitalCode.releaseDate}</Box>}
        {!dateAvailableAfterToday && <Button variant='outlined' onClick={handleOpen}>Get Code</Button>}
        <Dialog maxWidth='sm' fullWidth={true} open={modalOpen} onClose={handleClose}>
            <DialogTitle>
                <Stack
                    sx={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <Typography variant='h6' fontWeight={800}>Get Code</Typography>
                    <IconButton onClick={handleClose}>
                        <HighlightOffIcon/>
                    </IconButton>
                </Stack>
            </DialogTitle>
            <DialogContent sx={{minHeight: '200px'}}>
                <Typography variant="body1" fontWeight={800}>Digital Code</Typography>
                <IconButton
                    onClick={handleCopy}
                    sx={{display: 'inline'}}
                >
                    <ContentCopyIcon/>
                </IconButton>
                <Link href="#" onClick={handleCopy}>{digitalCode.code}</Link>

                <Typography variant="body1" fontWeight={800} sx={{mt: 2}}>Instructions</Typography>
                <Box sx={{maxHeight: '300px', overflow: 'scroll'}}>
                    <Markdown>
                        {digitalCode.instructions
                            .replaceAll("\\n", "\n")
                            .replaceAll("\\\"", "\"")
                        }
                    </Markdown>
                </Box>
            </DialogContent>
        </Dialog>
    </>;
};

export default DialogGetDigitalCode;
